const configureStore = (process.env.NODE_ENV === 'production') ? require('./configureStore.prod') : require('./configureStore.dev');
const store = configureStore.default();
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js